import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, forkJoin, tap } from "rxjs";
import { IUserNFTItemResponse, IUserLootboxItemsResponse, IGenericItem, ICraftableItemsResponse } from "./user-items.interface";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UserItemsService {

    private _lootboxItems: ReplaySubject<IUserLootboxItemsResponse[]> = new ReplaySubject<IUserLootboxItemsResponse[]>(1);
    private _nftItems: ReplaySubject<IUserNFTItemResponse[]> = new ReplaySubject<IUserNFTItemResponse[]>(1);
    private _allItems: ReplaySubject<IGenericItem[]> = new ReplaySubject<IGenericItem[]>(1);
    private _allItemsObj: IGenericItem[] = [];
    private _craftableItems: ReplaySubject<ICraftableItemsResponse> = new ReplaySubject<ICraftableItemsResponse>(1);
    constructor(
        private http: HttpClient
    ) {
        // this.lootboxItems$.subscribe(i => {
        //     i.forEach(li => this._allItemsObj.push(li));
        // });
        // this.nftItems$.subscribe(i => {
        //     i.forEach(nfti => {
        //         let newI: IGenericItem = {
        //             address: nfti.itemId,
        //             count: nfti.balance,
        //             type: nfti.metadata.name
        //         };
        //         this._allItemsObj.push(newI);
        //     });
        // });
    }

    getLootboxItems(wallet: string, limit: number = 1000): Observable<IUserLootboxItemsResponse[]> {
        return this.http.get(environment.apiBaseUrlV22 + 'user/' + wallet + '/items?limit=' + limit,
            { headers: { skipInterceptor: "true" } }
        ).pipe(
            tap((i: IUserLootboxItemsResponse[]) => {
                this._lootboxItems.next(i);
                this._allItemsObj = this.updateGenericItemsFromLootbox(i);
                this._allItems.next(this._allItemsObj);
            })
        )
    }

    get lootboxItems$(): Observable<IUserLootboxItemsResponse[]> {
        return this._lootboxItems.asObservable();
    }

    getNftItems(wallet: string, limit: number = 1000): Observable<IUserNFTItemResponse[]> {
        return this.http.get<IUserNFTItemResponse[]>(environment.apiBaseUrlV22 + 'user/' + wallet + '/nft-items?limit=' + limit,
            { headers: { skipInterceptor: "true" } }
        ).pipe(
            tap(i => {
                this._nftItems.next(i);
                this._allItemsObj = this.updateGenericItemsFromNft(i);
                this._allItems.next(this._allItemsObj);
            })
        )
    }

    getAllUserItems(wallet: string): Observable<any> {
        return forkJoin([
            this.getLootboxItems(wallet),
            this.getNftItems(wallet)
        ]);
    }

    get nftItems$(): Observable<IUserNFTItemResponse[]> {
        return this._nftItems.asObservable();
    }

    get allItems$(): Observable<IGenericItem[]> { //the structure will be the same of LootboxItems
        return this._allItems.asObservable();
    }

    private updateGenericItemsFromLootbox(litems: IUserLootboxItemsResponse[]) {
        let genericItems: IGenericItem[] = this._allItemsObj;
        litems.forEach((newItem) => {
            const existingIndex = genericItems.findIndex(
                (item) => item.type === newItem.type
            );
            if (existingIndex !== -1) {
                genericItems[existingIndex] = newItem;
            } else {
                genericItems.push(newItem);
            }
        });
        return genericItems;
    }

    private updateGenericItemsFromNft(nftItems: IUserNFTItemResponse[]): IGenericItem[] {
        let genericItems: IGenericItem[] = this._allItemsObj;
        nftItems.forEach((newItem) => {
            const existingIndex = genericItems.findIndex(
                (item) => item.address === newItem.itemId
            );
            if (existingIndex !== -1) {
                genericItems[existingIndex] = {
                    address: newItem.itemId,
                    count: newItem.balance,
                    type: newItem.metadata.name
                };
            } else {
                genericItems.push({
                    address: newItem.itemId,
                    count: newItem.balance,
                    type: newItem.metadata.name
                });
            }
        });
        return genericItems;
    }


    getCraftableInfo(itemTypeId: string): Observable<ICraftableItemsResponse> {
        return this.http.get<ICraftableItemsResponse>(environment.apiBaseUrlV22 + 'nft-items/' + itemTypeId + '/crafting').pipe(
            tap(res => this._craftableItems.next(res))
        )
    }

    get craftableItems$(): Observable<ICraftableItemsResponse> {
        return this._craftableItems.asObservable();
    }
}